<template>
    <div class="row">
        <div class="col-md-8">
            <div class="row mb-4">
                <div class="col-md-4">
                    <div :class="currentStep == 1 ? 'step-title active' : 'step-title'">بارگذاری تصویر</div>
                </div>
                <div class="col-md-4">
                    <div :class="currentStep == 2 ? 'step-title active' : 'step-title'">تنظیمات متن</div>
                </div>
                <div class="col-md-4">
                    <div :class="currentStep == 3 ? 'step-title active' : 'step-title'">تعداد و مبلغ شارژ</div>
                </div>
                <div class="col-md-12 mt-4">
                    <div :style="{display: currentStep == 1 ? 'unset' : 'none'}">
                        <div class="row create-cart-box justify-content-center" v-if="imageSrc">
                            <div class="col-md-8 text-center">
                                <img id="image" :src="imageSrc">
                                <button class="btn btn-custom mt-4 ml-1 btn-dark" @click="changeImage">تغییر تصویر</button>
                                <button class="btn btn-primary btn-custom mt-4" @click="currentStep++">مرحله بعد</button>
                            </div>
                        </div>
                        <div class="row justify-content-center text-center" v-else>
                            <p class="w-100 mb-2">تصویر مورد نظر خود را انتخاب کنید</p>
                            <div class="mt-3 mb-2">
                                <label for="custom-file-upload" class="filupp">
                                    <span class="filupp-file-name js-value">انتخاب تصویر</span>
                                    <input type="file" name="attachment-file" value="1" id="custom-file-upload" @change="setImage" accept="image/png,image/jpeg">
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-if="currentStep == 2">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="custom-label">متن مورد نظر خود را وارد کنید</label>
                                    <textarea class="form-control mb-1" rows="3" v-model="customText"></textarea>
                                    <small>این متن، در کنار کارت هدیه نمایش داده خواهد شد</small>
                                </div>
                            </div>
                            <div class="col-md-12 text-center">
                                <button class="btn btn-primary btn-custom wizard-button ml-1 mt-4" @click="currentStep--">مرحله قبل</button>
                                <button class="btn btn-primary btn-custom wizard-button mt-4" @click="currentStep++">مرحله بعد</button>
                            </div>
                        </div>
                    </div>
                    <div v-if="currentStep == 3">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row justify-content-center">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>انتخاب مبلغ شارژ</label>
                                            <select class="form-control mb-3" v-model="depositId">
                                                <option value="61">مبلغ دلخواه</option>
                                                <option v-for="(deposit,index) in depositsList" :key="index" :value="deposit.depositId">{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(deposit.depositValue) }} ریال</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-if="depositId == 61">
                                        <div class="form-group">
                                            <label>مبلغ دلخواه (ریال)</label>
                                            <input type="tel" class="form-control ltr-input" v-model="optionalCredit" @keyup="e => changeCustomDepositValue(e)" @change="handleMinAndMax">
                                        </div>
                                    </div>
                                    <div class="col-md-4 pl-0">
                                        <div class="form-group">
                                            <label>تعداد</label>
                                            <input type="number" min="0" max="10000" class="form-control ltr-input" placeholder="تعداد" value="0" v-model="itemsCount" @keyup="e => itemsCount = parseInt(itemsCount)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 text-center">
                                <button class="btn btn-primary btn-custom wizard-button ml-1 mt-1" v-if="imageSrc != ''" @click="currentStep--">مرحله قبل</button>
                                <button class="btn btn-success btn-custom wizard-button ml-1 mt-1" :disabled="disableButton || (!itemsCount || itemsCount < 1) ||  !depositId || (depositId == 61 && (!optionalCredit || optionalCredit == 0))" @click="saveImage" v-if="imageSrc != ''">تایید و افزودن به سبد</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <h6 class="custom-card-box-title">پیش نمایش</h6>
            <hr class="mb-4">
            <div id="preview-parent">
                <div id="preview-container" class="mt-3">
                    <img src="/assets/img/giftcard.png" class="card-template">
                    <div id="preview"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cropper from 'cropperjs';
import html2canvas from 'html2canvas';
import { Base64 } from '@/utils';

export default {
    name: 'CustomVisualCard',
    props: ['addToCard','depositsList'],
    data(){
        return {
            cardType: 4,
            imageSrc: '',
            imageUrl: '',
            customText: '',
            depositId: 0,
            optionalCredit: '',
            itemsCount: 0,
            disableButton: false,
            price: 0,
            currentStep: 1
        }
    },
    methods: {
        setImage(e){
            let reader = new FileReader();
            reader.onload = e => {
                this.imageSrc = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);
            setTimeout(() => {
                const image = document.getElementById('image');
                new Cropper(image,{
                    aspectRatio: 91.00 / 58.00,
                    viewMode: 1,
                    preview: '#preview',
                    autoCropArea: 0.8,
                    dragMode: 'move'
                });
            },100);
        },
        changeImage(){
            this.imageSrc = '';
            this.imageUrl = '';
            document.getElementsByClassName('cropper-container')[0].remove();
            document.getElementById('preview').childNodes[0].remove();
        },
        handleMinAndMax(e){
            let value = parseInt(e.target.value.toString().replace(/,/g,'')) || 0;
            if(value < 200000){
                this.$swal({
                    icon: 'error',
                    title: 'خطا',
                    text: 'کمترین مبلغ شارژ 200,000 ریال می باشد'
                });
                e.target.value = '';
            }
        },
        changeCustomDepositValue(e){
            let value = this.optionalCredit ? this.optionalCredit.replace(/,/gi,'') : 0;
            let numbers = /^[0-9]*$/;
            if(!numbers.test(e.target.value)){
                e.preventDefault();
            }
            if(value > 20000000)
                value = 20000000;
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            this.optionalCredit = value;
        },
        async saveImage(){
            this.disableButton = true;
            document.getElementById('preview-container').style.transform = 'unset';
            html2canvas(document.getElementById('preview-container')).then(canvas => {
                this.imageUrl = canvas.toDataURL('image/png');
            });
            document.getElementById('preview-container').style.transform = 'scale(0.32)';
            await html2canvas(document.getElementById('preview-container')).then(canvas => {
                let base64Data = canvas.toDataURL('image/png').replace('data:image/png;base64,','');
                this.minifyImageUrl = 'data:image/png;base64,' + base64Data;
            });
            let metaData = [
                {
                    key: 2,
                    base64: this.imageUrl
                }
            ];
            if(this.customText != '')
                metaData.push({
                    key: 3,
                    base64: 'data:text/plain;base64,' + Base64.encode(this.customText)
                });
            this.addToCard(0,'کارت هدیه مجازی',this.cardType,this.itemsCount,this.price,this.minifyImageUrl,this.depositId,this.optionalCredit,metaData);
            this.disableButton = false;
            this.currentStep = 1;
            this.depositId = 0;
            this.optionalCredit = '';
            this.itemsCount = 0;
            this.imageSrc = '';
            this.customText = '';
            this.imageUrl = '';
            document.getElementsByClassName('cropper-container')[0].remove();
            document.getElementById('preview').childNodes[0].remove();
        }
    },
    created(){
        this.$api.get('Config/VirtualCost').then(({data}) => {
            this.price = parseInt(data.result);
        });
    }
}
</script>